export const ossChipSx = ({ tone = "#64748b", bg = "#f8fafc", size = "small", strong = false } = {}) => ({
  height: size === "small" ? 24 : 30,
  minWidth: size === "small" ? 46 : 54,
  borderRadius: "999px",
  borderColor: `${tone}55`,
  bgcolor: bg,
  color: tone,
  fontSize: size === "small" ? 11.5 : 12.5,
  fontWeight: strong ? "900 !important" : "800 !important",
  letterSpacing: "0 !important",
  lineHeight: 1,
  "& .MuiChip-label": {
    px: size === "small" ? 1 : 1.25,
  },
  "& .MuiChip-icon": {
    ml: 0.75,
    mr: -0.35,
    color: "inherit",
    fontSize: size === "small" ? 16 : 18,
  },
});

export const neutralChipSx = ossChipSx({
  tone: "#475569",
  bg: "#f8fafc",
});

export const tableActionButtonSx = {
  height: 30,
  minWidth: 64,
  px: 1.05,
  borderRadius: "8px",
  fontSize: 12,
  fontWeight: "800 !important",
  "& .MuiButton-startIcon": {
    mr: 0.45,
    "& svg": {
      fontSize: 16,
    },
  },
};
